import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Romanian CNP generator following Single Responsibility Principle
 */
export class CnpGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null, gender = null, county = null } = options;

    // Gender and century digit (S)
    let s;
    if (gender === 'male') {
      s = this.randomInt(0, 1) ? '1' : '3'; // 1 for 1900-1999, 3 for 1800-1899
    } else if (gender === 'female') {
      s = this.randomInt(0, 1) ? '2' : '4'; // 2 for 1900-1999, 4 for 1800-1899
    } else {
      s = this.randomInt(1, 4).toString();
    }

    // Birth date (YYMMDD)
    let yymmdd;
    if (birthDate) {
      const date = new Date(birthDate);
      const year = date.getFullYear().toString().slice(-2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const day = this.padZero(date.getDate(), 2);
      yymmdd = year + month + day;
    } else {
      const year = this.padZero(this.randomInt(0, 99), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      yymmdd = year + month + day;
    }

    // County code (JJ) - 01-52
    const jj = county || this.padZero(this.randomInt(1, 52), 2);

    // Serial number (NNN) - 001-999
    const nnn = this.padZero(this.randomInt(1, 999), 3);

    // Calculate check digit
    const partial = s + yymmdd + jj + nnn;
    const weights = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += parseInt(partial[i]) * weights[i];
    }

    let checkDigit = sum % 11;
    if (checkDigit === 10) {
      checkDigit = 1;
    }

    return partial + checkDigit;
  }
}